import React, { useEffect } from 'react';
import { Modal, Form, DatePicker, InputNumber, Select, Input, message } from 'antd';
import dayjs from 'dayjs';
import { useFinanceApi, DOVIZ_OPTIONS, entityOptions } from '../api/financeApi';
import { inputNumberMoneyProps } from '../../../utils/currency';

/**
 * Creates an "Ödeme Talebi" from a kredi or çek.
 * POST /finance/{kind}/{id}/create-request   (kind = 'credits' | 'checks')
 */
export default function CreateRequestModal({ row, kind, lookups, onClose, onDone }) {
  const api = useFinanceApi();
  const [form] = Form.useForm();

  useEffect(() => {
    if (row) {
      form.setFieldsValue({
        tarih: dayjs(),
        vade: row.vade ? dayjs(row.vade) : (row.vade_bitis ? dayjs(row.vade_bitis) : dayjs()),
        tutar: row.tutar || row.taksit_tutar || row.odenecek,
        doviz: row.doviz || 'TRY',
        islem_turu_id: undefined,
        aciklama: '',
      });
    }
  }, [row, form]);

  const submit = async () => {
    let v;
    try { v = await form.validateFields(); } catch { return; }
    try {
      await api.post(`/${kind}/${row.id}/create-request`, {
        tarih: dayjs(v.tarih).format('YYYY-MM-DD'),
        vade: v.vade ? dayjs(v.vade).format('YYYY-MM-DD') : null,
        tutar: v.tutar,
        doviz: v.doviz,
        islem_turu_id: v.islem_turu_id,
        aciklama: v.aciklama,
      });
      message.success('Ödeme talebi oluşturuldu');
      onDone();
    } catch (e) {
      message.error(e?.response?.data?.detail || 'Talep oluşturulamadı');
    }
  };

  return (
    <Modal
      title="Ödeme Talebi Oluştur"
      open={!!row}
      onOk={submit}
      onCancel={onClose}
      okText="Talep Oluştur"
      cancelText="Vazgeç"
      destroyOnClose
    >
      <Form form={form} layout="vertical">
        <Form.Item name="tarih" label="Tarih" rules={[{ required: true }]}>
          <DatePicker style={{ width: '100%' }} format="DD.MM.YYYY" />
        </Form.Item>
        <Form.Item name="vade" label="Vade">
          <DatePicker style={{ width: '100%' }} format="DD.MM.YYYY" />
        </Form.Item>
        <Form.Item name="tutar" label="Tutar" rules={[{ required: true }]}>
          <InputNumber {...inputNumberMoneyProps} style={{ width: '100%' }} step={0.01} />
        </Form.Item>
        <Form.Item name="doviz" label="Döviz">
          <Select options={DOVIZ_OPTIONS} />
        </Form.Item>
        <Form.Item name="islem_turu_id" label="İşlem Türü" rules={[{ required: true }]}>
          <Select showSearch optionFilterProp="label"
            options={entityOptions(lookups, 'islem_turu', (i) => Number(i.odeme) === 1)} />
        </Form.Item>
        <Form.Item name="aciklama" label="Açıklama">
          <Input.TextArea rows={2} />
        </Form.Item>
      </Form>
    </Modal>
  );
}
